import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import { PLACEHOLDER_EXPERIENCE, useAggregatorClient } from '../../aggregator-client-context';
import { withProductContext } from '../product-router';
import RegisterProduct from './register-product';
/**
 * A component which invokes the permissionSupplier, if supplied or uses the Search Platform's default permission checker.
 * The calls to the default API are batched.
 * In response it expects the permissible sections that should be shown to the user.
 */
export var CheckProductPermissions = function CheckProductPermissions(_ref) {
  var children = _ref.children,
    permissionSupplier = _ref.permissionSupplier,
    id = _ref.id,
    title = _ref.title,
    sections = _ref.sections,
    order = _ref.order,
    generateAdvancedSearchUrl = _ref.generateAdvancedSearchUrl,
    expandedStateInputPlaceholder = _ref.expandedStateInputPlaceholder,
    workspaces = _ref.workspaces,
    autocorrectEnabled = _ref.autocorrectEnabled,
    showViewAllFiltersLink = _ref.showViewAllFiltersLink,
    tabRenderer = _ref.tabRenderer,
    aiSearchConfig = _ref.aiSearchConfig,
    showSearchOnEnter = _ref.showSearchOnEnter;
  var invokePostQuerySearchRef = useRef(function () {});
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    allowedSections = _useState2[0],
    setAllowedSections = _useState2[1];
  var searchClient = useAggregatorClient();
  useEffect(function () {
    if (allowedSections.length === 0) {
      // For Jira we need to improve performance by not rendering all the search dialog tabs before the
      // dialog is expanded. However, in order to ensure that the search component is interactive there needs
      // to be at least one allowed section. This test is a workaround to ensure that when there is only this
      // single dummy section that it is included without a permission check. This hook will be called again
      // when the search dialog is expanded and the real sections are provided.
      if (sections.length === 1 && sections[0].id === PERFORMANCE_IMPROVEMENT_DUMMY_SECTION) {
        setAllowedSections([PERFORMANCE_IMPROVEMENT_DUMMY_SECTION]);
        return;
      } else {
        var promise = permissionSupplier ? permissionSupplier() : searchClient ? searchClient.batchedGetExtensibleProductPermission(id, {
          productIds: [id],
          experience: PLACEHOLDER_EXPERIENCE
        }) : Promise.resolve([]);
        promise.then(function (response) {
          setAllowedSections(response);
        });
      }
    }
    /**
     * We want to replicate componentDidMount behaviour to avoid invoking the API multiple times and we don't care if any other deps changed.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return allowedSections.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RegisterProduct, {
    allowedSections: allowedSections,
    sections: sections,
    id: id,
    title: title,
    order: order,
    generateAdvancedSearchUrl: generateAdvancedSearchUrl,
    expandedStateInputPlaceholder: expandedStateInputPlaceholder,
    workspaces: workspaces,
    autocorrectEnabled: autocorrectEnabled,
    showViewAllFiltersLink: showViewAllFiltersLink,
    tabRenderer: tabRenderer,
    aiSearchConfig: aiSearchConfig,
    showSearchOnEnter: showSearchOnEnter,
    invokePostQuerySearchRef: invokePostQuerySearchRef
  }, children)) : /*#__PURE__*/React.createElement(React.Fragment, null);
};
export var PERFORMANCE_IMPROVEMENT_DUMMY_SECTION = '__PERFORMANCE_IMPROVEMENT_DUMMY_SECTION__';
export default withProductContext(CheckProductPermissions);